var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{attrs:{"type":_vm.type,"name":_vm.name},on:{"click":function($event){return _vm.$emit('btnClicked')}}},[_c('span',{staticClass:"button__icon"},[_c('fa-icon',{attrs:{"icon":_vm.faicon}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }